import { gql } from "@apollo/client"
// Define the mutation
export const MANAGE_DRIVER_ASSIGNMENT = gql`
    mutation ManageDriverAssignment($assignment: AssignDriverInput!) {
        manageDriverAssignment(assignment: $assignment) {
            success
        }
    }
`
